{
  "version": 1,
  "asset_id": "97981deb-848c-4673-9fc0-854060db8573",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/97981deb-848c-4673-9fc0-854060db8573/gastric-bypass-v2-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/97981deb-848c-4673-9fc0-854060db8573/gastric-bypass-v2-800.webp",
  "original_filename": "gastric-bypass-v2-800.webp",
  "size": 42932,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:01:06Z"
}
